import { render, staticRenderFns } from "./ProspectiveProjections.vue?vue&type=template&id=f31ad39c"
import script from "./ProspectiveProjections.vue?vue&type=script&lang=js"
export * from "./ProspectiveProjections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports